import React from 'react';

export const ContentDetailCardFooter = () => {
  return <div />;
};

ContentDetailCardFooter.propTypes = {};
